import type { AdminTermsPolicyItem } from "@/types";

const isPublishedAndEffective = (item: AdminTermsPolicyItem, businessDate: string) =>
  item.publishStatusCode === "PUBLISHED"
  && item.useYn === "Y"
  && Boolean(businessDate)
  && item.effectiveDate <= businessDate;

export const currentPublishedPolicyIds = (items: AdminTermsPolicyItem[], businessDate: string) => {
  const currentByType = new Map<string, AdminTermsPolicyItem>();

  items.filter((item) => isPublishedAndEffective(item, businessDate)).forEach((item) => {
    const current = currentByType.get(item.termsTypeCode);
    if (!current
      || item.effectiveDate > current.effectiveDate
      || (item.effectiveDate === current.effectiveDate && item.termsPolicyId > current.termsPolicyId)) {
      currentByType.set(item.termsTypeCode, item);
    }
  });

  return new Set(Array.from(currentByType.values(), (item) => item.termsPolicyId));
};

export const versionedPublicPath = (item: AdminTermsPolicyItem) => {
  const separator = item.publicPath.includes("?") ? "&" : "?";
  return `${item.publicPath}${separator}version=${encodeURIComponent(item.version)}`;
};
